// TODO we need only one TabContent for both settings and security

import classNames from 'classnames';
import React, { ReactNode } from 'react';

interface Props {
  name: string;
  id?: string;
  children?: ReactNode;
  sticky?: boolean;
}

export const SecurityTabContent: React.FunctionComponent<Props> = ({ name, id, children, sticky }) => {
  return (
    <div id={id} className={classNames('security-tab-content', sticky && 'sticky')}>
      {name && <div className="security-tab-name haiui-heading-04-med">{name}</div>}
      {children}
    </div>
  );
};
